// deviceTypeIcon — small MUI icon per device type, for the part-progress chips
// ("where is this step executing"). Keyed by the same domain enum the
// monitoring module uses for its hero photos (deviceTypeImage.js): STORAGE,
// CMM, EDM, MACHINING_CENTER, HANDLER, POLISHING_CENTER, OPERATOR,
// IDENTIFICATION, MARKING, CLEANING_CENTER, TREATMENT_CENTER,
// DEBURRING_CENTER, PRINTER_3D. Unknown/absent type renders no icon (the chip
// keeps its state glyph), so steps without an assigned device stay clean.
import React from 'react'
import {
  AutoAwesome,
  Bolt,
  CleaningServices,
  ContentCut,
  DriveFileRenameOutline,
  LocalFireDepartment,
  Person,
  PrecisionManufacturing,
  QrCode2,
  SmartToy,
  Straighten,
  ViewInAr,
  Warehouse
} from '@mui/icons-material'

const ICON_BY_TYPE = {
  STORAGE: Warehouse,
  CMM: Straighten,
  EDM: Bolt,
  MACHINING_CENTER: PrecisionManufacturing,
  HANDLER: SmartToy,
  POLISHING_CENTER: AutoAwesome,
  OPERATOR: Person,
  IDENTIFICATION: QrCode2,
  MARKING: DriveFileRenameOutline,
  CLEANING_CENTER: CleaningServices,
  TREATMENT_CENTER: LocalFireDepartment,
  DEBURRING_CENTER: ContentCut,
  PRINTER_3D: ViewInAr
}

/**
 * @param {Object} props
 * @param {String} props.deviceTypeName Domain enum value (e.g. `device.deviceType.name`)
 * @returns {JSX.Element|String} a 13px icon, or '' when the type is unknown/absent
 */
export const DeviceTypeIcon = ({ deviceTypeName = '' }) => {
  const Icon = ICON_BY_TYPE[String(deviceTypeName).toUpperCase()]
  if (!Icon) {
    return ''
  }
  return <Icon sx={{ fontSize: 13 }} titleAccess={deviceTypeName} />
}
